import { gql } from '@apollo/client';

export const GET_TOP_CAR_REGISTRATION_YEARS = gql`
  query GetTopCarRegistrationYears($filters: DistributionGraphsInput) {
    getTopCarRegistrationYears(input: $filters) {
      amountOfListings
      label
    }
  }
`;
